<div [ngClass]="{ div__missao_depentende: ehMissaoDependente }">
  <div
    class="card__desafio"
    (click)="abrirDetalhes()"
    [ngClass]="definirImagemBackgroundCard()"
    style="z-index: 2"
  >
    <div
      [ngClass]="{
        'card--clicavel': desafioAceito || statusId == missaoExpirada
      }"
      (click)="onClickCard()"
    >
      <div class="desafio__padding">
        <app-timer
          [finalDate]="fimDesafio"
          [timeActivateCard]="exibirTimer"
          *ngIf="!desafioAceito"
        ></app-timer>
        <p
          class="lbl__titulo_missao lbl__misao_completada"
          *ngIf="statusId === missaoCompletada"
        >
          <img src="assets/images/icons/mission_completed.png" />
          Missão concluída
        </p>
        <p
          class="lbl__titulo_missao lbl__missao_expirada"
          *ngIf="statusId === missaoExpirada && !desafioAceito"
        >
          Missão Expirada
        </p>

        <p
          class="lbl__titulo_missao lbl__missao_expirada__iniciado"
          *ngIf="statusId === missaoExpirada && desafioAceito"
        >
          <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.3752 2.25003V7.87503C11.3748 7.93319 11.3599 7.99048 11.3318 8.04249C11.3036 8.09451 11.2628 8.13985 11.2127 8.17503C10.4459 8.70941 9.70954 8.89691 9.00876 8.89691C8.05408 8.89691 7.1654 8.54534 6.33767 8.22191C4.98181 7.68285 3.80369 7.21878 2.43767 8.06722V10.125C2.43767 10.2245 2.39487 10.3199 2.31868 10.3902C2.2425 10.4605 2.13916 10.5 2.03142 10.5C1.92368 10.5 1.82034 10.4605 1.74416 10.3902C1.66797 10.3199 1.62517 10.2245 1.62517 10.125V2.22191C1.62441 2.2153 1.62621 2.20866 1.63025 2.20316V2.18441C1.63025 2.17972 1.63533 2.17503 1.63533 2.16566C1.63533 2.15628 1.6404 2.15628 1.6404 2.1516C1.6404 2.14691 1.64548 2.13753 1.64548 2.13285C1.64548 2.12816 1.65056 2.12347 1.65056 2.11878C1.65056 2.1141 1.65564 2.10472 1.66072 2.10003C1.6621 2.09302 1.66563 2.08651 1.67087 2.08128C1.67087 2.0766 1.67595 2.07191 1.67595 2.06722L1.68611 2.04847C1.69119 2.04378 1.69626 2.0391 1.69626 2.03441L1.7115 2.02035L1.72165 2.00628L1.73689 1.99222L1.74705 1.97816L1.76228 1.96878L1.78259 1.95472H1.78767C3.60056 0.69847 5.22556 1.34066 6.65759 1.90785C8.08962 2.47503 9.28806 2.94847 10.7252 1.95472C10.7852 1.91317 10.8565 1.88776 10.9312 1.88132C11.0059 1.87488 11.081 1.88766 11.1484 1.91824C11.2157 1.94882 11.2725 1.99601 11.3125 2.05457C11.3525 2.11314 11.3742 2.18079 11.3752 2.25003Z"
              fill="#FFA81E"
            />
          </svg>
          Missão iniciada e expirada
        </p>

        <div
          class="desafio__infos"
          [ngClass]="{
            'desafio__info-timer': exibirTimer == true,
            desafio__height__completed: statusId == missaoCompletada
          }"
        >
          <p
            class="infos__titulo"
            [ngClass]="{
              infos_missao_ativa: statusId == missaoAtiva
            }"
          >
            {{ titulo }}
          </p>
          <p class="infos__validade" *ngIf="statusId != missaoCompletada">
            <span *ngIf="!exibirTimer && !exibirTimerDias">
              Válido até {{ fimDesafio | date : "dd/MM" }}
            </span>
          </p>
        </div>

        <p *ngIf="statusId == missaoCompletada" class="lbl__ganhou">
          Você ganhou
        </p>
        <div
          class="desafio__recompensas"
          [ngClass]="{
            desafio__recompensa_completed: statusId == missaoCompletada,
            'ajust--timer': desafioAceito && exibirTimer,
            ajust__pontos__expirado: statusId == missaoExpirada,
            'ajust--com--iniciada': statusId === missaoExpirada && desafioAceito
          }"
        >
          <div
            class="recompensas__recompensa"
            *ngIf="valorCacausRecompensa > 0"
          >
            <p
              [ngClass]="{
                recompensa__texto_gradiente: statusId == missaoAtiva,
                recompensa__texto_gray: statusId == missaoExpirada
              }"
              class="recompensa__texto"
            >
              <img
                src="assets/images/icons/cacau_moeda.png"
                class="img__cacaus_gradiente"
              />
              {{ "+" + valorCacausRecompensa }}
              <span
                class="lbl__pontuacao"
                *ngIf="exibirDescritivoPontosECacaus()"
                >{{ valorCacausRecompensa > 1 ? "cacaus" : "cacau" }}</span
              >
            </p>
          </div>
          <div
            class="recompensas__recompensa"
            *ngIf="valorPontosRecompensa > 0"
          >
            <p
              [ngClass]="{
                recompensa__texto_gradiente: statusId == missaoAtiva,
                recompensa__texto_gray: statusId == missaoExpirada
              }"
              class="recompensa__texto"
            >
              <img
                src="assets/images/icons/pontos_gradiente.svg"
                class="img__pontos_gradiente"
              />
              {{ " +" + valorPontosRecompensa }}
              <span
                class="lbl__pontuacao"
                *ngIf="exibirDescritivoPontosECacaus()"
                >{{ valorPontosRecompensa > 1 ? "pontos" : "ponto" }}</span
              >
            </p>
          </div>
        </div>

        <div
          class="div__iniciar"
          *ngIf="!desafioAceito && statusId != missaoExpirada"
        >
          <button
            class="btn__iniciar"
            [ngClass]="{ btn__missao_dependente: ehMissaoDependente }"
            (click)="onClick()"
          >
            <span *ngIf="ehMissaoDependente"
              >{{ indexGrupoMissaoDependente }} /
              {{ countMissoesDependente }}</span
            >
            Iniciar
            <img src="assets/images/icons/play.svg" />
          </button>
        </div>

        <div
          class="footer__progresso"
          *ngIf="desafioAceito && statusId == missaoAtiva"
        >
          <div
            class="progresso__aceito"
            *ngIf="!exibirTimerDias && !exibirTimer && diffInDays > 30"
          >
            <img
              class="img__iniciado"
              src="assets/images/icons/flag.svg"
              alt="Bandeira"
            />
            <p class="texto__iniciado">Missão iniciada!</p>
          </div>

          <app-timer
            [finalDate]="fimDesafio"
            [timeActivateCard]="exibirTimer"
            [desafioAceito]="desafioAceito"
            *ngIf="desafioAceito"
          ></app-timer>

          <app-timer
            [finalDate]="fimDesafio"
            [timeActivateDays]="exibirTimerDias"
            [diffDays]="diffInDays"
            *ngIf="exibirTimerDias"
          ></app-timer>
        </div>
      </div>
    </div>
  </div>
  <!-- Cards do fundo-->
  <div
    *ngFor="let item of obterNumeroCards(); let i = index"
    class="card__desafio"
    [ngClass]="[definirImagemBackgroundCard(), 'card__dependente_' + i]"
  >
    <div>
      <div class="desafio__padding"></div>
    </div>
  </div>
</div>

<!-- #region Popups -->

<lovers-popup
  [exibir]="exibirPopupDesafio"
  (onClose)="fecharPopup()"
  [tamanho]="caminhoImagem || caminhoImagemMobile ? 'desafio' : 'pequeno'"
>
  <div
    class="lovers__desafio__popup"
    [ngClass]="{
      'popup--sem-imagem': !caminhoImagem && !caminhoImagemMobile,
      'popup--com-texto': exibirTextoDeAceite()
    }"
  >
    <div
      *ngIf="caminhoImagem || caminhoImagemMobile"
      [ngClass]="{ imagem: exibirTextoDeAceite() }"
    >
      <img
        class="desafio__imagem"
        [src]="caminhoImagem"
        [ngClass]="{ desafio__imagem_border: exibirTextoDeAceite() }"
      />
      <img class="desafio__imagem--mobile" [src]="caminhoImagemMobile" />
    </div>

    <div class="desafio__info">
      <div class="popup__header">
        <app-timer
          [finalDate]="fimDesafio"
          [timeActivateDays]="exibirTimerDias"
          [ajust__popup]="exibirPopupDesafio"
          [diffDays]="diffInDays"
          *ngIf="exibirTimerDias && (desafioAceito || !desafioAceito)"
        ></app-timer>
        <app-timer
          [finalDate]="fimDesafio"
          [timeActivateCard]="exibirTimer"
          [ajust__popup]="exibirPopupDesafio"
          [desafioAceito]="desafioAceito"
          *ngIf="exibirTimer && (desafioAceito || !desafioAceito)"
        ></app-timer>
        <p class="header__title" *ngIf="!exibirTimer && !exibirTimerDias">
          {{
            desafioIniciado && porcentagemDesafio < 100
              ? "Missão iniciada!"
              : desafioIniciado && porcentagemDesafio >= 100
              ? "Parabéns, você concluiu a missão!"
              : desafioEstaExpirado()
              ? "Opa, essa missão acabou..."
              : "Aceita essa missão?"
          }}
        </p>
        <div class="tabs" *ngIf="ehMissaoDependente">
          <button
            *ngFor="let item of listaMissoesDependente; let i = index"
            [ngClass]="{ btn__selecionado: obterClassTabSelecionado(i) }"
            (click)="onClickTabMissao(item)"
          >
            <span *ngIf="desafioCompletado(item)">
              <img src="assets/images/icons/check_orange.png" />
            </span>
            Missão {{ i + 1 }}
          </button>
        </div>
        <p class="header__subtitle text__vermelho">
          {{ titulo }}
        </p>
        <p class="data_validade">
          Missão válida de {{ inicioDesafio | date : "dd/MM/yyyy" }} a
          {{ fimDesafio | date : "dd/MM/yyyy" }}
        </p>
      </div>
      <div
        class="popup__body"
        [ngClass]="{
          'possui-descritivo': this.exibirTextoDeAceite(),
          'possui-tabs': this.ehMissaoDependente
        }"
      >
        <div class="descricao descricao__desafio">
          {{ descricao }}
        </div>
      </div>
      <div class="popup__footer texto">
        <div
          *ngIf="!desafioEstaExpirado()"
          class="recompensa__container"
          [ngClass]="{
            recompensa__container_completed: porcentagemDesafio >= 100
          }"
        >
          <p class="desafio__recompensa" *ngIf="valorPontosRecompensa > 0">
            <img
              class="recompensa__icone"
              src="assets/images/icons/pontos_amarelo.png"
            />
            {{ "+" + valorPontosRecompensa }}
            <span> Ponto{{ valorPontosRecompensa > 1 ? "s" : "" }} </span>
          </p>
          <p class="desafio__recompensa" *ngIf="valorCacausRecompensa > 0">
            <img
              class="recompensa__icone icone--cacau"
              src="assets/images/icons/cacau_moeda.png"
            />
            {{ "+" + valorCacausRecompensa }}
            <span> Cacau{{ valorCacausRecompensa > 1 ? "s" : "" }} </span>
          </p>
        </div>
        <!-- <div class="footer__content" *ngIf="desafioAceito">
          <button class="lovers-button quiz__btn" (click)="abrirQuiz()" *ngIf="desafioAceito && ehQuizz">Quiz</button>
        </div> -->
        <div
          class="footer__content"
          *ngIf="!desafioAceito || linkVamosLa !== ''"
        >
          <button
            class="lovers-button vamos-la__btn"
            (click)="clickOkButton()"
            [disabled]="disableBtnIniciair()"
            *ngIf="desafioAceito != true && !desafioEstaExpirado()"
          >
            Iniciar
            <img *ngIf="!loadingPopup" src="assets/images/icons/play.svg" />
            <i *ngIf="loadingPopup" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>
    </div>
    <div
      class="descritivo"
      [ngClass]="{ padding__descritivo: caminhoImagem }"
      *ngIf="this.exibirTextoDeAceite()"
    >
      <hr style="margin: 8px 0" />
      <div class="text__descritivo" [innerHTML]="this.descricaoDeAceite"></div>
    </div>
  </div>
</lovers-popup>

<lovers-popup
  [exibir]="exibirPopupDesafioExpirado"
  (onClose)="exibirPopupDesafioExpirado = false"
  tamanho="pequeno"
>
  <div class="popup__header">
    <p class="header__title">Opa, essa missão acabou...</p>
    <br />
    <p class="header__subtitle text__vermelho">{{ titulo }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao descricao__desafio">
      {{ descricao }}
    </div>
  </div>
</lovers-popup>

<lovers-popup
  [exibir]="exibirPopupQuizz"
  (onClose)="exibirPopupQuizz = false"
  tamanho="pequeno"
>
  <div class="quizz_div" *ngIf="idQuizz > 0">
    <div class="desafio__descricao">
      <div class="desafio__header">
        <p class="header__titulo_desafio">{{ titulo }}</p>
      </div>
      <app-quizz
        id="quizz"
        [IdQuizz]="idQuizz"
        [UsuarioLogado]="usuarioLogado"
        [Titulo]="titulo"
      ></app-quizz>
    </div>
  </div>
</lovers-popup>

<lovers-popup
  [exibir]="exibirPopupDesafioCompletado"
  (onClose)="exibirPopupDesafioCompletado = false"
  [tamanho]="caminhoImagem || caminhoImagemMobile ? 'desafio' : 'pequeno'"
>
  <div
    class="lovers__desafio__popup"
    [ngClass]="{ 'popup--sem-imagem': !caminhoImagem && !caminhoImagemMobile }"
  >
    <div *ngIf="caminhoImagem || caminhoImagemMobile">
      <img class="desafio__imagem" [src]="caminhoImagem" />
      <img class="desafio__imagem--mobile" [src]="caminhoImagemMobile" />
    </div>

    <div class="desafio__info">
      <div class="popup__header">
        <p class="header__title">Parabéns, você concluiu a missão!</p>
        <p class="header__subtitle text__vermelho">{{ titulo }}</p>
      </div>
      <div class="popup__body">
        <div class="descricao descricao__desafio">
          {{ descricao }}
        </div>
      </div>
      <div class="popup__footer">
        <div
          class="recompensa__container recompensa__container_completed"
          [ngClass]="{ 'esconder-completo': desafioCompleto }"
        >
          <p class="desafio__recompensa" *ngIf="valorPontosRecompensa > 0">
            <img
              class="recompensa__icone"
              src="assets/images/icons/pontos_amarelo.png"
            />
            {{ valorPontosRecompensa }}
            <span> Ponto{{ valorPontosRecompensa > 1 ? "s" : "" }} </span>
          </p>
          <p class="desafio__recompensa" *ngIf="valorCacausRecompensa > 0">
            <img
              class="recompensa__icone icone--cacau"
              src="assets/images/icons/cacau_moeda.png"
            />
            {{ valorCacausRecompensa }}
            <span> Cacau{{ valorCacausRecompensa > 1 ? "s" : "" }} </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</lovers-popup>

<!-- endregion -->
